import { useSearchParams } from "react-router-dom";

export const useSearchQuery = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    // const query = searchParams.get(params) || defaultQuery;

    const setQuery = (queryObj) => {
        let newQuery = new URLSearchParams()
        Object.keys(queryObj).forEach((key, value) => {
            // return newQuery.set(key, queryObj[key]);
            if (value !== null && value !== undefined) {
                newQuery.set(key, queryObj[key]);
            } else {
                // If value is null or undefined, remove the key from the search parameters
                newQuery.delete(key);
            }
        })
        
        setSearchParams(newQuery);
    };

    return [setQuery];
};